export default __webpack_public_path__ + "static/media/shared.7f2cdf6e.svg";